import React, { useEffect } from 'react'

import { LntSwitch } from '@app/components/base'

import { SIZE } from '@app/constants'

import { useUserQuery } from '@app/hooks'

import permissionService from '@app/services/permissionService'

import { Role } from '@app/types'

import type { Column } from '@app/components/base/Table/types'
import type { ManagingMonitoringsDataSource } from '../../types'
import type { PatchTypesData } from '@app/api/routes/monitorings/types'

const { hasOneOfRoles } = permissionService
const roles: Role[] = ['administrator', 'price_analytics_specialist']

export const useIsActiveColumn = (
  columns: Array<Column<ManagingMonitoringsDataSource>>,
  onChange: (data: PatchTypesData) => void
): void => {
  // TODO: Вынести в отдельный хук проверку роли
  const { data: user } = useUserQuery()
  let canEdit = false
  if (user?.roles) {
    canEdit = hasOneOfRoles(user.roles, roles)
  }

  useEffect(() => {
    const isActiveColumn = columns.find(column => column.key === 'isActive')

    if (isActiveColumn) {
      isActiveColumn.render = (_, { isActive, key }) => {
        return (
          <LntSwitch
            size={ SIZE.small }
            checked={ isActive }
            disabled={ !canEdit }
            onChange={ value =>
              onChange({
                id: key,
                isActive: value
              })
            }
          />
        )
      }
    }
  }, [])
}
